import { useTheme } from "@mui/material";
import { createSxStyles } from "../../common/createSxStyles";

export const useContentStyles = () => {
    const theme = useTheme();

    return createSxStyles({
        content: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            borderRadius: theme.spacing(4),
            position: "relative",
            padding: 3,
            minHeight: "100vh",
        },
        breadCrumbs: {
            marginBottom: theme.spacing(2),
        },
    });
};
